import { defineMessages } from 'react-intl';

export default defineMessages({
  includedCertsTitle: {
    id: 'BundleCertDetails.includedCertsTitle',
    defaultMessage:
      'Certificates that are included in the {certName} certificate summary:',
  },
  certsFilesTitle: {
    id: 'BundleCertDetails.certsFilesTitle',
    defaultMessage: 'Attached files to the certificate:',
  },
  certItem: {
    id: 'BundleCertDetails.certItem',
    defaultMessage:
      '{name} {supervisorOrganization} {supervisor}, certificate no {code}',
  },
});
